import Icon from 'components/UI/Icon';
import { PillListMenu } from 'navigation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import './SupplierList.scss';
import { Helmet } from 'react-helmet';
const BackButton = require('img/navigationIcons/backbutton.svg');
function SupplierList({ goBack }) {
    const suppliers = useSelector((state) => state.products.suppliers);
    const { t } = useTranslation();
    const menuItems = suppliers
        ? suppliers.map((s) => ({
            text: s.name,
            navigationPath: `/supplier/${s.id}`,
        }))
        : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null, "Leverand\u00F8rer - Morgenlevering"),
            React.createElement("meta", { property: "og:title", content: "Leverand\u00F8rer - Morgenlevering" }),
            React.createElement("meta", { property: "og:url", content: "https://morgenlevering.no/supplier" })),
        React.createElement("div", { className: 'supplier-list__menu' },
            React.createElement("div", { className: 'supplier-list__header', onClick: goBack },
                React.createElement(Icon, { svg: BackButton, size: 'large' }),
                React.createElement("h2", { className: 'supplier-list__title' }, t('mobileNavigationBack'))),
            React.createElement(PillListMenu, { heading: t('suppliersPillListHeader'), items: menuItems }))));
}
export default SupplierList;
